import React, { useState } from "react";
import { motion } from "framer-motion";
import CreatePositionTab from "../InterviewScheduleForm/createPositionTab";
import { useNavigate } from "react-router-dom";
import bgImage from "../../assets/images/bg-img.jpg";

const InterviewScheduleForm = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    positionTitle: "Software Engineer",
    technologies: "React and Node.js",
    minExperience: "2",
    maxExperience: "5",
    resume: null,
    jdFile: null,
    jdText: "",
    similarityScore: null,
    error: null,
    uploadProgress: 0,
    setError: null,
  });
  const [jD, setJD] = useState();
  const [errors, setErrors] = useState({});
  const [position, setPosition] = useState();
  const [technologies, setTechnologies] = useState();
  const [maxExperience, setMaxExperience] = useState();
  const [minExperience, setMinExperience] = useState();
  const navigate = useNavigate();
  const [isPreviousClicked, setIsPreviousClicked] = useState(false);
  const [isSaved, setIsSaved] = useState(true);
  const [jobId, setJobId] = useState();
  const [isSaveClicked, setIsSaveClicked] = useState(false);

  const nextStep = () => {
    if (jobId) {
      navigate(`/setup-mcq?id=${jobId}`);
    }
  };

  // const prevStep = () => {
  //   if (currentStep > 0) {
  //     setCurrentStep(currentStep - 1);
  //     setIsPreviousClicked(true);
  //   }
  // };

  return (
    <>
      <div
        className=" p-6 min-h-[calc(100vh-20px)]"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <motion.div
          key={currentStep}
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ duration: 0.5 }}
        >
          {currentStep === 0 && (
            <CreatePositionTab
              formData={formData}
              setFormData={setFormData}
              errors={errors}
              setErrors={setErrors}
              setJD={setJD}
              jD={jD}
              setPosition={setPosition}
              setMaxExperience={setMaxExperience}
              setMinExperience={setMinExperience}
              setTechnologies={setTechnologies}
              isPreviousClicked={isPreviousClicked}
              isSaved={isSaved}
              setIsSaved={setIsSaved}
              setJobId={setJobId}
              jobId={jobId}
              isSaveClicked={isSaveClicked}
              setIsSaveClicked={setIsSaveClicked}
            />
          )}
        </motion.div>
        <div
          className=" p-2 flex justify-end items-center bottom-8 left-0 right-0 "
          style={
            {
              // backgroundColor: "#060d1b",
            }
          }
        >
          {/* <button
            className={`flex items-center gap-2 px-5 py-2 rounded-lg font-medium transition-all 
             ${
               currentStep === 0
                 ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                 : "bg-blue-800 text-white hover:bg-blue-900"
             }
           `}
            onClick={prevStep}
            disabled={currentStep === 0}
          >
            <i className="fa fa-arrow-left"></i> Previous
          </button> */}

          <div className="flex gap-2">
            <motion.button
              className={`flex items-center gap-2 px-5 py-2 text-white  rounded-lg font-medium transition-all ${
                isSaved && isSaveClicked
                  ? " bg-blue-700 hover:bg-blue-800"
                  : " bg-blue-400 cursor-not-allowed"
              }`}
              onClick={nextStep}
              disabled={!isSaveClicked}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Next <i className="fa fa-arrow-right"></i>
            </motion.button>
          </div>
        </div>
      </div>
    </>
  );
};

export default InterviewScheduleForm;
